import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.002 16" width="1em" height="1em" {...props}><g color="#000" fill="#2e3436"><path d="M7.936 2l-7.934.01L0 13.979h9.969l.027-9.918C9.996 2.936 9.06 2 7.936 2zM3.018 5h1c.31 0 .552.09.75.281L7.424 8l-2.656 2.719c-.198.19-.44.281-.75.281h-1v-1c0-.257.13-.528.312-.719L4.611 8l-1.28-1.281c-.184-.19-.313-.462-.313-.719z" style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        whiteSpace: "normal",
        isolation: "auto",
        mixBlendMode: "normal",
        solidColor: "#000",
        solidOpacity: 1,
        marker: "none"
      }} fontWeight={400} fontFamily="sans-serif" overflow="visible" /><path d="M9.986 2.031s1.032.484 1.032 1.969v10h.984V4c0-1.25-2.016-1.969-2.016-1.969zM11.97 2.031s1.032.484 1.032 1.969v10h1V4c0-1.25-2.031-1.969-2.031-1.969z" style={{
        isolation: "auto",
        mixBlendMode: "normal",
        solidColor: "#000",
        solidOpacity: 1,
        marker: "none"
      }} overflow="visible" /></g></svg>;
}

export default SvgComponent;